import { useCallback, useContext } from 'react';
import { ModalContext } from './ModalProvider';
import { ModalOptions, ShowFn } from './types';

type ConfirmOptions = ModalOptions & {
  onConfirm: () => Promise<any>;
}

const useConfirm = () => {
  const ctx = useContext(ModalContext);

  if (!ctx) {
    throw Error('The `useConfirm` hook must be called from a descendent of the `ModalProvider`.');
  }

  const confirmDelete = useCallback((options: ConfirmOptions) =>
    ctx.show({...options, type: 'delete'}),
    [ctx.show]);

  return {
    confirmDelete,
  };
};

export default useConfirm;
